import cn from "classnames";
import { MacStageMeta } from "../MacChart/MacChart.constants";

interface MacChartStageFooterProps {
    stage: MacStageMeta;
    index: number;
    isSelectable: boolean;
    isSelected: boolean;
    onToggle: () => void;
}

function MacChartStageFooter({ stage, index, isSelectable, isSelected, onToggle }: MacChartStageFooterProps) {
    const content = (
        <>
            <span className="MacChart__footer-name">{stage.name}</span>
            <span className="MacChart__footer-detail">{stage.detail}</span>
        </>
    );

    if (!isSelectable) {
        return (
            <div className="MacChart__footer is-centered" data-testid={`blockMacDetailsChartCol-${index}`}>
                {content}
            </div>
        );
    }

    return (
        <button
            type="button"
            role="checkbox"
            aria-checked={isSelected}
            className={cn('MacChart__footer', 'is-selectable', { 'is-selected': isSelected })}
            onClick={onToggle}
            data-testid={`blockMacDetailsChartCol-${index}`}
        >
            <span className="MacChart__footer-checkbox" aria-hidden/>
            <span className="MacChart__footer-text">{content}</span>
        </button>
    );
}

export default MacChartStageFooter;
